<template>
  <div class="container galleries" id="galleries">
    <div class="content-heading is-flex">
      <h3 class="is-size-3">Galleries</h3>
      <router-link to="/admin/galleries/new" class="button is-info">Add New</router-link>
    </div>

    <!-- modal for post delete -->
    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" @confirmDeletePost='confirmDelete()' @selectBulkActions='selectBulkActions()' v-if="showModal" :header="header"/>
    </transition>

    <router-view></router-view>

    <div class="box">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th @click="sortBy('title')">
              Title
            </th>
            <th>
              State
            </th>
            <th>
              Images
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(gallery, index) in galleries" :key="index">
            <td>
              <p>
                <router-link :to="'/admin/galleries/edit/' + gallery['.key']">
                  {{gallery.title}}
                </router-link>
              </p>
              <div v-html="gallery.description"></div>

              <div class="actions">
                <router-link :to="'/admin/galleries/edit/' + gallery['.key']">
                  <span class="has-text-info">Edit</span>
                </router-link>
                <span @click="deleteGallery(gallery)" class="has-text-danger">Delete</span>
              </div>
            </td>
            <td>{{gallery.state}}</td>
            <td>{{(gallery.images) ? gallery.images.length : 0}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { galleriesRef } from '@/firebase_config'
import modal from '@/components/shared/Modal'

export default {
  name: 'galleries',
  data () {
    return {
      showModal: false,
      header: '',
      kind: '',
      gallery: null,
      sortKey: 'title'
    }
  },
  firebase: {
    galleries: galleriesRef
  },
  computed: {},
  methods: {
    deleteGallery (gallery) {
      this.header = 'Are you sure you want to delete this gallery?'
      this.kind = 'deletePost'
      this.showModal = true
      this.gallery = gallery
    },
    confirmDelete () {
      this.$firebaseRefs.galleries.child(this.gallery['.key']).remove().then(() => {
        // this.showNotification('success', 'Gallery deleted successfully')
        this.showModal = false
        this.gallery = ''
      })
    }
  },
  components: {
    modal
    // dropdown,
    // checkbox
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/Galleries.vue